var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from 'react';
import { EyeTableIcon } from '@/presentation/components/icons';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { manageIndividualClassAtom } from '../components/atoms';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { mapToCardinal } from '@/presentation/functions/cardinal';
import { manageStudentsAtom } from '../../manage-students/components/atoms';
import { useNavigate } from 'react-router';
const UseManageIndividualClass = (loadUsersPaginated, loadUsers, manageClasses, idClass, idClient, getClass, Styles, manageQuizzesUsers, managePreQuiz) => {
    const [state, setState] = useRecoilState(manageIndividualClassAtom);
    const { getIdClient, user } = useUserSesssion();
    const setmanageStudentState = useSetRecoilState(manageStudentsAtom);
    const [studentsWithExtraColumns, setStudentsWithExtraColumns] = useState([]);
    const navigate = useNavigate();
    const [allData, setAllData] = useState([]);
    const [score, setScore] = useState(null);
    useEffect(() => {
        getStudentsPaginated(state.filters);
    }, [state.filters.input, state.reloadStudents]);
    useEffect(() => {
        getClassById(idClass);
    }, [state.reoladClassData]);
    useEffect(() => {
        getClassById(idClass);
        getTeachers();
        getStudentsPaginated(state.filters);
        getClassList();
    }, []);
    const getClassList = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const response = yield manageClasses.getClassesByClientId(idClient);
        if (response)
            setmanageStudentState(prev => (Object.assign(Object.assign({}, prev), { classList: response, isLoading: false })));
    });
    const changeLoading = (value) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isTableLoading: value });
        });
    };
    const getClassById = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const classById = yield getClass.getClassById({ id });
        setState(prev => (Object.assign(Object.assign({}, prev), { class: classById })));
    });
    const getStudentsPaginated = (filters, pagination = {
        pageIndex: 1,
        pageSize: 10
    }, sort) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading(true);
        const clientId = getIdClient();
        const ROLE_STUDENT = '11';
        const filterProps = {
            rolesIds: [ROLE_STUDENT],
            input: filters.input,
            clientsIds: [clientId.toString()],
            studentClassesIds: [idClass.toString()],
            selectedGradeId: filters.selectedGradeId
        };
        const students = yield loadUsersPaginated.getUsers(filterProps, sort, pagination);
        changeLoading(false);
        console.log('STUDENTSSSSS 11111', students);
        let averageScore = 0;
        const values = students.data.map(student => {
            averageScore = averageScore + student.studentScorePercent;
        });
        setScore(averageScore);
        if (students && students.total > 0 && students.data.length > 0) {
            setStudentsWithExtraColumns(students);
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { students: {
                        data: students.data,
                        count: students.count,
                        total: students.total,
                        page: students.page,
                        pageCount: students.pageCount
                    }, dataNotFound: false });
            });
        }
        else {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { students: {
                        data: [],
                        count: 0,
                        total: 0,
                        page: 0,
                        pageCount: 0
                    }, dataNotFound: true });
            });
        }
    });
    const getAllData = () => __awaiter(void 0, void 0, void 0, function* () {
        const filters = state === null || state === void 0 ? void 0 : state.filters;
        const clientId = getIdClient();
        changeLoading(true);
        let statusIds = [];
        if (filters.deleted) {
            statusIds = ['1', '2', '3', '4'];
        }
        else {
            statusIds = ['1', '2', '3'];
        }
        let studentClassesIds = [];
        if (filters.selectedClassId && filters.selectedClassId !== '0') {
            studentClassesIds = [filters.selectedClassId];
        }
        const filterProps = {
            rolesIds: ['11'],
            statusIds,
            studentClassesIds,
            clientsIds: [clientId.toString()]
        };
        const students = yield loadUsersPaginated.getAllUsers(filterProps);
        changeLoading(false);
        if (students && students.length > 0) {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { allStudents: students });
            });
            return students;
        }
        else {
            setAllData([]);
            return [];
        }
    });
    const getTeachers = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isLoading: true });
        });
        const clientId = getIdClient();
        const TEACHER_ROLE = '10';
        const filterProps = {
            clientsIds: [clientId.toString()],
            rolesIds: [TEACHER_ROLE]
        };
        const teachers = yield loadUsers.getUsers(filterProps);
        if (teachers && teachers.length > 0) {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { teachers: teachers });
            });
        }
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isLoading: false });
        });
    });
    const columnAlternativeNames = {
        firstName: 'Name',
        email: 'Email',
        grades: 'Grade',
        // cumulativeGrade: 'Cumulative grade',
        preQuiz: 'Pre-Quiz Avg. Score',
        cumulativeScore: 'Cumulative Score',
        view: 'View'
    };
    const columnsWithoutSort = ['view'];
    const setColumnsByModel = () => {
        const keys = ['firstName', 'email', 'grades', 'preQuiz', 'cumulativeScore'];
        const columns = keys.map(key => {
            return Object.assign({ accessorFn: row => row[key], id: key, cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames[key]), enableSorting: false, sortingFn: () => 0 }, getColumnSize(key));
        });
        columns.push(Object.assign({ accessorFn: row => row.view, id: 'view', cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames.view), enableSorting: false, sortingFn: () => 0 }, sizeProps(5)));
        return columns;
    };
    const sizeProps = (size) => ({ size, maxSize: size, minSize: size });
    const getColumnSize = (key) => {
        switch (key) {
            case 'firstName':
                return sizeProps(20);
            case 'email':
                return sizeProps(30);
            case 'grades':
                return sizeProps(15);
            /* case 'cumulativeGrade':
              return sizeProps(15); */
            default:
                return sizeProps(10);
        }
    };
    const renderCumulativeScore = (row) => {
        var _a;
        const classData = row && row.studentClasses && row.studentClasses.find(item => item.classes_id === idClass);
        return React.createElement("span", null, `${(_a = (classData === null || classData === void 0 ? void 0 : classData.cumulativeScore) * 100) !== null && _a !== void 0 ? _a : '0'}%`);
    };
    const columns = useMemo(() => [...setColumnsByModel()], []);
    const mapClassesGrade = (classes) => {
        const classNames = classes === null || classes === void 0 ? void 0 : classes.map(item => {
            var _a;
            return (_a = mapToCardinal(item === null || item === void 0 ? void 0 : item.grades)) === null || _a === void 0 ? void 0 : _a.join(', ');
        });
        return classNames === null || classNames === void 0 ? void 0 : classNames.join(', ');
    };
    const renderCellByType = (context, row) => {
        const { column } = context;
        console.log(row);
        switch (column.id) {
            case 'firstName':
                return React.createElement("span", { className: Styles.blue },
                    `${row === null || row === void 0 ? void 0 : row.firstName} ${row === null || row === void 0 ? void 0 : row.lastName}`,
                    " ");
            case 'email':
                return React.createElement("span", null, row === null || row === void 0 ? void 0 : row.email);
            case 'grades':
                return React.createElement("span", null, mapClassesGrade(row === null || row === void 0 ? void 0 : row.classesS));
            case 'preQuiz':
                return React.createElement("span", null,
                    (row === null || row === void 0 ? void 0 : row.studentProgressPercentPreQuizz) || 0,
                    "%");
            case 'cumulativeScore':
                return React.createElement("span", null,
                    (row === null || row === void 0 ? void 0 : row.studentScorePercent) || 0,
                    "%");
            /* case 'cumulativeGrade':
              return <span>{renderCumulativeScore(row)}</span>; */
            case 'view':
                return (React.createElement("div", { className: Styles.actionWrap },
                    React.createElement(EyeTableIcon, { onClick: () => navigate(user.role.description === 'Teacher'
                            ? `/teacher-dashboard/student-information/${row.id}?manageClass=true&classId=${idClass}`
                            : `/school-dashboard/manage-student/${row.id}`) })));
            default:
                return React.createElement("span", null);
        }
    };
    const mapDataForCSV = (dataToExport) => {
        try {
            if ((dataToExport === null || dataToExport === void 0 ? void 0 : dataToExport.length) > 0) {
                return dataToExport === null || dataToExport === void 0 ? void 0 : dataToExport.map(item => ({
                    name: `${item === null || item === void 0 ? void 0 : item.firstName} ${item === null || item === void 0 ? void 0 : item.lastName}`,
                    email: item === null || item === void 0 ? void 0 : item.email,
                    grade: mapClassesGrade(item === null || item === void 0 ? void 0 : item.classesS),
                    preQuizAvgScore: `${(item === null || item === void 0 ? void 0 : item.preQuiz) || 0}%`,
                    CumulativeScore: `${(item === null || item === void 0 ? void 0 : item.cumulativeScore) || 0}%`
                }));
            }
        }
        catch (error) {
            console.error(error);
        }
        return [];
    };
    return {
        columns,
        columnsWithoutSort,
        getStudentsPaginated,
        renderCellByType,
        mapDataForCSV,
        getAllData,
        score
    };
};
export default UseManageIndividualClass;
